module.exports = __webpack_public_path__ + "static/media/login.2060dc1b.svg";